import { useState } from "react";
import axios from "axios";
export const useAxios = (baseurl, endpoint, options = {
  method: "POST"
}) => {
  const [states, setStates] = useState({
    initial: true,
    loading: false,
    complete: true,
    error: null,
    success: null,
    response: null
  });
  return { ...states,

    call(overideOptions = {}) {
      setStates(prev => ({ ...prev,
        loading: true,
        complete: false
      }));
      return axios({ ...options,
        ...overideOptions,
        url: `${baseurl}${'url' in overideOptions ? overideOptions.url : endpoint}`,
        headers: { ...options.headers,
          ...overideOptions?.headers
        }
      }).then(response => {
        setStates(prev => ({ ...prev,
          initial: false,
          loading: false,
          complete: true,
          error: null,
          success: null,
          response: response.data
        }));
        return response;
      }).catch(error => {
        setStates(prev => ({ ...prev,
          initial: false,
          loading: false,
          complete: true,
          success: null,
          error: error.message
        }));
        return Promise.reject(error);
      });
    },

    setError(error) {
      setStates(prev => ({ ...prev,
        error
      }));
    },

    setSuccess(success) {
      setStates(prev => ({ ...prev,
        success
      }));
    },

    setResponse(response) {
      setStates(prev => ({ ...prev,
        response
      }));
    }

  };
};